import React from 'react';
import AccordionContent from './AccordionContent';

interface ScienceStudiesContentProps {
  content: string;
}

const ScienceStudiesContent: React.FC<ScienceStudiesContentProps> = ({ content }) => {
  return <AccordionContent content={content} className="science-studies-content" />;
};

export default ScienceStudiesContent;
